// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_CreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos_categorias/create
 *
 * Returns the new service category id under {servicoscategoria_id}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ServicosCategorias_CreateResponseDados {
servicoscategoria_id?: number
}

export type ServicosCategorias_CreateResponse = ApiResponse<ServicosCategorias_CreateResponseDados>;

registerResponseContract('ServicosCategorias_CreateResponse', {
  servicoscategoria_id: { type: 'number',  required: false },
})
